export function queryStringEncoding(str, type = "encode") {
  return type === "encode" ? encodeURI(str) : decodeURI(str);
}

export const queryString = {
  parse: function (queryStr) {
    let params = {};
    if (queryStr !== "") {
      if (queryStr.indexOf("?") === 0) queryStr = queryStr.substring(1);
      let queryArray = queryStr.split("&");
      queryArray.forEach(element => {
        let keyVal = element.split("=");
        params[decodeURI(keyVal[0])] = decodeURI(keyVal[1]);
      });
    }
    return params;
  },
  stringify: function (queryObject) {
    let str = "";
    for (var key in queryObject) {
      if (queryObject.hasOwnProperty(key)) {
        if (str === "") str += encodeURI(key) + "=" + encodeURI(queryObject[key]);
        else str += "&" + encodeURI(key) + "=" + encodeURI(queryObject[key]);
      }
    }
    return str;
  }
};

export const generateQueryStringFromReduxState = query => {
  let q = {};

  //Location
  if (query.location.category === "Country") {
    q.countryId = query.location.id;
  } else if (query.location.category === "State") {
    q.stateId = query.location.id;
    q.destination = query.location.name;
  } else {
    if (query.location.id) {
      q.locationId = query.location.id;
      q.destination = query.location.name;
    }
  }

  //Category
  if (query.type && query.type !== "") {
    q.type = query.type;
  }

  //Price
  if (query.price.to) {
    q.priceFrom = query.price.from;
    q.priceTo = query.price.to;
  }

  //Date
  if (query.date.from) {
    q.from = query.date.from;
    q.to = query.date.to;
  }

  //Sorting
  if (query.sort.sort) {
    q.sort = query.sort.sort;
    q.order = query.sort.order;
  }

  //Tour type
  if (query.tourType) {
    q.tourType = query.tourType;
  }

  return q;
};

export const detectClickOutSide = (container, target) => {
  if (!container.contains(target)) {
    return false;
  }
};

export function convertBudgetValueAccordingToCurrency(value, currency) {
  if (currency === "USD" || currency === "EUR") {
    return value;
  } else if (currency === "INR") {
    return value * 100;
  }
}